import type { QuotePolicy } from '@core/types/api/QuotePolicy/QuotePolicy';
import type { Tenant } from '@core/types/api/Tenant/Tenant';
import type { List } from '@core/types/list';

export type GetTenantRequiresApprovalsParams = {
  tenant: Tenant;
  quotePolicies: List<QuotePolicy> | undefined;
};

export const getTenantRequiresApprovals = ({
  quotePolicies,
}: GetTenantRequiresApprovalsParams): boolean => {
  if (quotePolicies === undefined) {
    return false;
  }
  return quotePolicies.count > 0;
};
